import { accountAPI, kycAPI, profileAPI } from "services";
import { stringSort, numSort } from "utils";

/** Keep only own or shared accounts depending on the active tab */
export const splitByKhataType = (accounts, KhataType) =>
    accounts.filter((account) =>
        KhataType === "shared"
            ? accountAPI.checkIsSharedAccount(account)
            : !accountAPI.checkIsSharedAccount(account)
    );


/** get owner name & phone for each shared account*/
export const reMapSharedAccounts = async (accounts, cache) =>
    Promise.all(
        accounts.map(async (account) => {
            const user = account.get("userId");
            const userId = user?.id;

            if (!userId) return account;

            if (!cache.current[userId]) {
                const profile = await profileAPI.getProfileBasics(user);
                let phoneNumber = profile?.contact?.phoneNumber;

                if (!phoneNumber) {
                    const creator = (await kycAPI.getUserByUserId(userId)) || "";
                    phoneNumber = creator?.get?.("username");
                }

                cache.current[userId] = {
                    name: profile?.business?.name || "Unknown",
                    phone: phoneNumber
                        ? `+${phoneNumber}`
                        : "",
                };
            }

            const { name, phone } = cache.current[userId];
            account.set("name", name);
            account.set("phone", phone);
            return account;
        })
    );

/** Filter accounts by search term (name or phone) */
export const applySearch = (accounts, search) => {
    if (!search.trim()) return accounts;
    const term = search.toLowerCase();
    return accounts.filter((account) => {
        const name = (account.get("name") || "").toLowerCase();
        const phone = account.get("phone") || "";
        return name.includes(term) || phone.includes(search);
    });
};

/** Filter accounts by selected tag */
export const applyTagFilter = (accounts, selectedTag) => {
    if (!selectedTag) return accounts;
    return accounts.filter((account) =>
        account.get("tag")?.includes(selectedTag)
    );
};

/** Sort accounts by name or balance */
export const applySort = (accounts, sort) =>
    sort.col === "balance"
        ? numSort(accounts, sort.desc, sort.col)
        : stringSort(accounts, sort.desc, sort.col);

/** Remove cancelled/closed accounts when the toggle is on */
export const applyHideClosed = (accounts, hideClosed) =>
    hideClosed ? accounts.filter((a) => !a.get("cancelled")) : accounts;
